module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    key: _vm.attribute.definitionId,
    staticClass: "definition-node",
    class: [{
      'selected': _vm.isSelected,
      'in-group': _vm.inGroup,
      'is-first': _vm.isFirst,
      'is-last': _vm.isLast,
      'is-removed': _vm.attribute.removed,
      'cant-drop-here': !_vm.canDropHere,
    }, _vm.levelClass],
    attrs: {
      "disabled": _vm.disableDefinitionPart,
      "draggable": _vm.isDraggable && !_vm.thisPartIsInACountGroup
    },
    domProps: {
      "innerHTML": _vm._s(_vm.displayName)
    },
    on: {
      "click": _vm.clickHandler,
      "dblclick": function($event) {
        return _vm.editAttribute($event)
      },
      "dragstart": _vm.dragStartHandler,
      "dragover": _vm.dragOverHandler,
      "dragleave": _vm.dragLeaveHandler,
      "drop": _vm.dropHandler,
      "dragend": _vm.dragEndHandler,
      "mouseover": _vm.showUEHoverOver,
      "mouseout": _vm.hideUEHoverOver
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ab97c38"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/targetDefinition/targetDefinitionStatement/DefinitionNode.vue
// module id = 1871
// module chunks = 0